<template>
    <div>
        <div class="card shadow">
            <div class="card-header bg-transparent">
                <div>
                    <h3 class="mb-0">
                        {{ $t('message.edit') }} {{ $tc('message.prescriptions', 1) }}
                    </h3>
                </div>
            </div>

            <div class="card-body">
                <b-form v-if="show">
                    <b-container>
                        <b-row>
                            <b-col sm="12">
                                <span  class="obligatoire">*</span>
                                <b-form-group
                                        id="date_prescription-group"
                                        :label="$t('message.prescriptionDate')"
                                        label-for="date_prescription">
                                    <b-form-input
                                            id="date_prescription"
                                            v-model="$v.form.date_prescription.$model"
                                            :state="$v.form.date_prescription.$dirty ? !(errorshasField('date_prescription') || $v.form.date_prescription.$error) : null"
                                            type="date"
                                            placeholder=""
                                    ></b-form-input>
                                    <b-form-invalid-feedback v-if="errorshasField('date_prescription')">
                                        {{ getErrorsField('date_prescription') }}
                                    </b-form-invalid-feedback>

                                    <b-form-invalid-feedback v-if="$v.form.date_prescription.$error">
                                        {{ $t('message.requiredField') }}
                                    </b-form-invalid-feedback>

                                </b-form-group>
                            </b-col>
                            <b-col sm="12">
                                <span  class="obligatoire">*</span>

                                <b-form-group
                                        id="medicaments-group"
                                        :label="$tc('message.drug',2)"
                                        label-for="medicaments"
                                >
                                    <select id="medicaments" v-model="$v.form.medicamentsId.$model"
                                            @change="clearErrorField('medicaments')"
                                            @click="clearErrorField('medicaments')"
                                            class="form-control is-invalid retirerBordure"
                                            required
                                            multiple
                                    >
                                        <option data-placeholder="true"></option>
                                        <option v-for="item in mMedicaments" :key="item.id" :value="item.id">
                                            {{ item.nom }}
                                        </option>
                                    </select>
                                    <b-form-invalid-feedback v-if="$v.form.medicamentsId.$error">
                                        {{ $t('message.requiredField') }}
                                    </b-form-invalid-feedback>

                                    <b-form-invalid-feedback v-if="errorshasField('medicaments')">
                                        {{getErrorsField('medicaments')}}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>

                        </b-row>
                    </b-container>

                    <b-container>
                        <b-row class="justify-content-sm-center" v-if="can">
                            <b-button  @click="onSubmit" variant="primary">
                                {{ $t('message.edit') }}
                            </b-button>
                        </b-row>
                    </b-container>
                </b-form>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from "vuex";
    import _ from "lodash";
    import SlimSelect from "slim-select";
    import {required} from "vuelidate/lib/validators";
    import moment from "moment";

    export default {
        name: "EditPrescription",
        computed: {
            ...mapGetters(["prescription","drugs", "errors", 'hasAdminRole',
                'hasMedecinControleRole', 'hasPraticienRole','hasAssistante']),

            can:function () {
                if (this.hasAdminRole || this.hasGestionnaireRole || this.hasAssistante){
                    return true;
                }else if ( this.hasPraticienRole ){
                    return  this.form.isAuthor
                }
                return false;
            },

            form: function() {
                let ordonance = this.prescription;
                let mArray= [];
                _.forEach(ordonance.medicaments, function (medicament) {
                    mArray.push(medicament.id);
                });
                ordonance['medicamentsId'] = mArray;
                ordonance['date_prescription'] = moment(ordonance.date_prescription).format('YYYY-MM-DD');
                return ordonance;
            },

            mMedicaments:function () {
                let mArray = [];
                _.forEach(this.drugs,function (drug) {
                    mArray.push({nom:drug.nom_commercial,id:drug.id})
                });

                return mArray;
            }
        },

        data(){
            return{
                show:true,
                prescription_id:  this.$route.params.prescription
            }
        },
        methods: {
            onSubmit(evt){
                evt.preventDefault();

                this.$v.$touch();

                if(!this.$v.$invalid){
                    let args = {
                        ordonance : this.prescription_id,
                        dossier_medical_id:this.prescription.dossier.slug,
                        date_prescription:this.form.date_prescription,
                        medicaments:this.form.medicamentsId,
                    };

                    let successMessage = this.$i18n.t('message.prescriptionUpdated');
                    let errorMessages = {
                        generic: this.$i18n.t('message.genericError'),
                        error: this.$i18n.t('message.genericError') // TODO: Prendre message approprié
                    };

                    this.$store.dispatch('updatePrescription', { args, errorMessages, successMessage });
                }
            },

            listeDesMedicaments() {
                let args = {
                    offset: this.offset,
                    limit: this.limit
                };

                this.$store.dispatch('getDrugs', { args : args });
            },

            ordonance(){
                let args = {
                    ordonance: this.prescription_id
                };

                this.$store.dispatch("getPrescription", {args});
            },

            getErrorsField(field){
                if (this.errorshasField(field)){
                    return this.errors[field][0];
                }else{
                    return  '';
                }
            },

            errorshasField(field){
                return this.errors ? this.errors.hasOwnProperty(field) : false;
            },

            clearErrorField(field){
                this.$store.dispatch('clearErrorField', { field });

                this.getErrorsField(field);
            }
        },

        mounted() {

            this.listeDesMedicaments();

            this.ordonance();

            new SlimSelect({
                select: '#medicaments',
                placeholder: 'Select',
                limit:3
            });
        },

        validations() {
            return {
                form:{
                    date_prescription: {required},
                    medicamentsId:{required},
                },
            }
        }
    }
</script>

<style scoped>

</style>